import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg, { makeArticleSchema, makeBreadcrumbSchema, makeWebPageSchema } from '@/components/feature/SchemaOrg';
import { latestArticles, featuredManhwa } from '@/mocks/home';

const articleContents: Record<number, { content: string; relatedIds: number[] }> = {
  1: {
    content: `<p>2026年，韩国漫画市场持续繁荣，每月都有大量新作涌现。面对琳琅满目的选择，漫迷们该如何挑选值得一读的好作品呢？我们编辑部精心筛选了十部最具潜力的新作，希望能为你的阅读清单提供参考。</p>
    <h4>1. 《星空下的约定》</h4>
    <p>一部融合了科幻与浪漫元素的独特作品。故事讲述在近未来的太空殖民时代，一位地球女孩与外星文明的王子之间跨越星际的恋情。画风精美细腻，太空场景的描绘令人惊叹。</p>
    <h4>2. 《暗夜君主》</h4>
    <p>吸血鬼题材的又一力作。不同于传统的哥特风格，本作将故事背景设定在现代首尔，讲述了隐藏在都市阴影中的吸血鬼社会内部权力斗争。暗色调的画面风格与故事氛围完美契合。</p>
    <h4>3. 《厨神之路》</h4>
    <p>美食竞技类韩漫的新标杆。主角是一名失去味觉的天才厨师，为了找回味觉并实现成为顶级厨师的梦想，踏上了环游世界学习料理的旅程。每一话都会介绍一道精美的料理，让人垂涎欲滴。</p>`,
    relatedIds: [2, 4, 6],
  },
  2: {
    content: `<p>近年来，韩国漫画（Webtoon）在全球范围内的影响力呈指数级增长。从韩国本土到日本、中国、东南亚，再到欧美市场，韩漫的读者群体正在迅速扩张。那么，韩漫为何能在如此短的时间内取得如此惊人的成绩呢？</p>
    <h4>独特的内容生态</h4>
    <p>韩漫最大的特点是其"条漫"（垂直滚动）的阅读形式，完美适配了智能手机时代的阅读习惯。读者只需上下滑动手指，就能流畅地阅读漫画，大大降低了阅读门槛。全彩的画面也让韩漫在视觉上更具吸引力。</p>
    <h4>丰富多元的题材</h4>
    <p>韩漫涵盖了极其广泛的题材类型。从传统的恋爱、奇幻、动作，到职场、美食、恐怖、悬疑，韩漫几乎触达了所有可能的细分领域。这种多元化的内容策略，使得不同类型的读者都能在韩漫中找到自己喜欢的作品。</p>`,
    relatedIds: [1, 3, 5],
  },
  3: {
    content: `<p>对于刚接触韩漫的新手来说，选择从哪里开始阅读可能是第一道门槛。目前市面上有众多韩漫阅读平台，各有特色和优势。本文将从多个维度为你详细分析，帮你找到最适合自己的阅读入口。</p>
    <h4>韩国本土平台</h4>
    <p>Naver Webtoon是全球最大的网络漫画平台之一，拥有最丰富的韩漫资源库。Kakao Webtoon（原KakaoPage）则侧重于付费内容，拥有大量独家签约的高质量作品。这两个平台是韩漫的核心阵地。</p>
    <h4>中文平台推荐</h4>
    <p>对于中文读者来说，咚漫（隶属于Naver Webtoon）是获取正版韩漫的最佳选择之一。平台提供简体中文翻译，更新速度较快，且支持免费阅读部分章节。此外，一些综合性的漫画导航网站也能帮您快速找到所需资源。</p>`,
    relatedIds: [1, 4, 6],
  },
  4: {
    content: `<p>奇幻题材是韩国漫画中最受欢迎的类型之一。从剑与魔法的西方奇幻，到融合东方元素的玄幻世界，优秀的奇幻韩漫总能构建出令人沉浸的宏大世界观。以下是编辑部精心评选的奇幻类韩漫TOP20。</p>
    <h4>西方奇幻类</h4>
    <p>这类作品通常以欧洲中世纪风格为背景，包含剑士、魔法师、龙、精灵等经典奇幻元素。代表作包括《剑与魔法》、《龙之契约》等，故事格局宏大，战斗场面震撼。</p>
    <h4>东方玄幻类</h4>
    <p>融合了中国武侠、仙侠元素与韩国本土文化特色的独特类型。这类作品往往以修炼、飞升、门派争斗为主线，深受亚洲读者喜爱。代表作《剑道至尊》在多个平台均取得了极高的评分。</p>`,
    relatedIds: [1, 2, 5],
  },
  5: {
    content: `<p>近年来，越来越多的韩国漫画被改编成电视剧，这一趋势正在加速。有些改编剧大获成功，但也有不少漫画读者认为"原著比改编更好看"。今天我们就来盘点那些值得一读的韩漫原著。</p>
    <h4>改编成功的典范</h4>
    <p>《梨泰院Class》的漫画原著相比电视剧有着更加丰富的人物内心刻画和情节细节。漫画中主角的创业历程描写得更加细致，让人更能体会到奋斗的不易与成功的喜悦。如果你喜欢这部剧，强烈推荐阅读原著漫画。</p>
    <h4>被低估的原著</h4>
    <p>有些韩漫原著的精彩程度远远超过了改编作品。《她的秘密花园》的漫画版本在情节展开和悬疑氛围的营造上，都比改编作品更加出色。漫画中那些细腻的画面和情感表达，是影视化难以完全呈现的。</p>`,
    relatedIds: [2, 3, 4],
  },
  6: {
    content: `<p>恋爱题材是韩漫永恒的经典。从青涩的校园初恋到成熟的都市爱情，从甜蜜的日常相处到虐心的虐恋情节，韩漫中的恋爱故事总能触动读者内心最柔软的部分。</p>
    <h4>校园纯爱</h4>
    <p>校园恋爱是韩漫中最具代表性的恋爱类型之一。这类作品往往以高中或大学校园为背景，描绘青春期的悸动、暗恋的甜蜜与苦涩。《时光里的我们》就是一部校园恋爱的经典之作，讲述了一对青梅竹马从相知到相爱的温暖故事。</p>
    <h4>都市言情</h4>
    <p>都市背景的恋爱韩漫通常面向成年读者，涉及职场爱情、契约婚姻、先婚后爱等成熟题材。这类作品在情感描写上更加细腻深入，人物关系也更加复杂多元。</p>`,
    relatedIds: [1, 3, 5],
  },
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const numId = parseInt(id || '1', 10);
  const article = latestArticles.find((a) => a.id === numId) || latestArticles[0];
  const contentData = articleContents[numId] || articleContents[1];
  const relatedArticles = (contentData?.relatedIds || [1, 2, 3])
    .map((rid) => latestArticles.find((a) => a.id === rid))
    .filter(Boolean) as typeof latestArticles;

  const relatedManhwa = featuredManhwa.slice(0, 3);

  return (
    <>
      <SchemaOrg {...makeArticleSchema(
        article.title,
        article.excerpt,
        article.author,
        article.date,
        article.thumbnail,
      )} />
      <SchemaOrg {...makeWebPageSchema(
        article.title,
        article.excerpt,
        `https://www.example.com/article/${article.id}`,
      )} />
      <SchemaOrg {...makeBreadcrumbSchema([
        { name: '首页', url: 'https://www.example.com/' },
        { name: '文章资讯', url: 'https://www.example.com/article/1' },
        { name: article.title, url: `https://www.example.com/article/${article.id}` },
      ])} />
      <Navbar />
      <main className="pt-16">
        {/* Breadcrumb */}
        <nav className="px-4 md:px-6 py-4 bg-background-100" aria-label="面包屑导航">
          <div className="max-w-4xl mx-auto flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            <Link to="/category/romance" className="hover:text-primary-600 transition-colors">文章资讯</Link>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            <span className="text-foreground-700 font-medium">{article.title}</span>
          </div>
        </nav>

        {/* Article Content */}
        <article className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <header className="mb-8">
              <div className="flex items-center gap-2 mb-4">
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs font-medium">
                  {article.categoryName}
                </span>
                <span className="text-foreground-400 text-xs">{article.date}</span>
                <span className="text-foreground-400 text-xs">· 阅读 {article.readTime}</span>
              </div>

              <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
                {article.title}
              </h1>

              <div className="flex items-center gap-3 text-foreground-500 text-xs">
                <span>作者：{article.author}</span>
                <div className="flex flex-wrap gap-1.5">
                  {article.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-md text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </header>

            {/* Featured Image */}
            <div className="aspect-video rounded-xl overflow-hidden mb-8 bg-background-200">
              <img
                src={article.thumbnail}
                alt={article.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content Body */}
            <div
              className="prose prose-sm max-w-none text-foreground-800 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: contentData.content }}
            />

            {/* Related Articles */}
            <div className="mt-14 pt-10 border-t border-background-200">
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-6">相关文章</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.id}`}
                    className="group p-4 bg-background-100 rounded-xl hover:bg-background-200 transition-colors cursor-pointer"
                  >
                    <h4 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                      {ra.title}
                    </h4>
                    <p className="text-foreground-500 text-xs">{ra.date}</p>
                  </Link>
                ))}
              </div>
            </div>

            {/* Related Manhwa */}
            <div className="mt-10 pb-4">
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-6">推荐漫画</h3>
              <div className="grid grid-cols-3 gap-4" data-product-shop="true">
                {relatedManhwa.map((item) => (
                  <Link
                    key={item.id}
                    to={`/article/${item.id}`}
                    className="group cursor-pointer"
                  >
                    <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-2 bg-background-200">
                      <img
                        src={item.cover}
                        alt={item.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <h4 className="font-heading text-xs font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                      {item.title}
                    </h4>
                    <p className="text-foreground-500 text-xs">{item.author}</p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}